import React, {useContext, useEffect, useState} from "react";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {Breadcrumb, Button, Checkbox, Form, Image, Input, notification, Select, Space, Spin, Upload} from "antd";
import DB_ProductsGroups from "../../../../database/dictionary/products-group";
import DB_Unit from "../../../../database/dictionary/unit";
import DB_Product, {picture_upload} from "../../../../database/dictionary/product";
import axios from "axios";
import VendorCode from "./vendor_code";
import {useTranslation} from "react-i18next";
import ModalWindow from "../../../modal";
import {Context} from "../../../../App";
import DB_PatternActivity from "../../../../database/dictionary/pattern-activity";
import {UploadOutlined} from "@ant-design/icons";
import BackButton from "../../../tech/back_button";


const EditProducts = () => {
    const {token, setToken} = useContext(Context);
    const {getActivePatternActivities} = DB_PatternActivity(token);
    const {getProduct, createProduct, updateProduct} = DB_Product(token);
    const {getActiveProductsGroups} = DB_ProductsGroups(token);
    const {getActiveUnits} = DB_Unit(token);
    const {t} = useTranslation();
    const {errorConnect} = ModalWindow();
    const params = useLocation().state;
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [isLoadSystem, setIsLoadSystem] = useState(true)
    const [wait, setWait] = useState(true);
    const [isActive, setIsActive] = useState()
    const [patternActivities, setPatternActivities] = useState([])
    const [productsGroup, setProductsGroup] = useState([])
    const [unit, setUnit] = useState([])
    const [pictureFile, setPictureFile] = useState()
    const [picture, setPicture] = useState()

    // useEffect(() => {
    //     if(params.copy === null){
    //         navigate("/products", {replace: true});
    //     }
    // }, [])
    const getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    };

    const handleChange = (info) => {
        setPictureFile(info.file.originFileObj)
        if (info.file.status === 'done') {
            getBase64(info.file.originFileObj, url => {
                setPicture(url);
            });
        }
    };



    // const CopyButton = () => {
    //     if (params.copy === null && params.id != null) {
    //         return (
    //             <Button type={'ghost'} onClick={() => copyProduct()}>{t('copy')}</Button>
    //         )
    //     }
    // }

    const openNotificationFailedActive = (type, who) => {
        notification.error({
            message: t('failed'),
            description:
                t('e_inactive', {type: type, what: t('product').toLowerCase(), who: who}),
            placement: 'top'
        });
    };
    const openNotificationFailed = (action) => {
        notification.error({
            message: t('failed'),
            description:
                t('e_update_create', {action: action, type: t('branch').toLowerCase()}),
            placement: 'top'
        });
    };


    useEffect(() => {
        if (!isLoadSystem) {
            if (params.id != null) {
                getProduct(params.id)
                    .then(res => {
                        setIsActive(Boolean(res.data.status));

                        if (res.data.product_group_id[0].status === 0) {
                            res.data.product_group_id.map(grp => {
                                setProductsGroup(current => [...current, grp]);
                            })
                        }

                        if (res.data.unit[0].status === 0) {
                            res.data.unit.map(u => {
                                setUnit(current => [...current, u]);
                            })
                        }

                        res.data['pattern_activity'].map(p => {
                            if (p.status === 0) {
                                setPatternActivities(current => [...current, p])
                            }
                        })

                        form.setFieldsValue({
                            name: res.data.name,
                            name_short: res.data.name_short,
                            product_group_id: res.data.product_group_id[0].id,
                            weight: res.data.weight,
                            unit: res.data.unit[0].id,
                            amount_in_a_package: res.data.amount_in_a_package,
                            pattern_activity: res.data.pattern_activity.map(p => p.id),
                            weight_product: !!res.data.weight_product
                        })
                        setPicture(res.data.picture)
                        setWait(false);
                    })
                    .catch((e) => {
                        if (e.request.status === 403) {
                            setToken(null)
                        } else {
                            setWait(false)
                            errorConnect()
                        }
                    });
            } else if (params.copy != null) {
                getProduct(params.copy)
                    .then(res => {
                        if (res.data.product_group_id[0].status === 0) {
                            res.data.product_group_id.map(grp => {
                                setProductsGroup(current => [...current, grp]);
                            })
                        }

                        if (res.data.unit[0].status === 0) {
                            res.data.unit.map(u => {
                                setUnit(current => [...current, u]);
                            })
                        }

                        res.data['pattern_activity'].map(p => {
                            if (p.status === 0) {
                                setPatternActivities(current => [...current, p])
                            }
                        })

                        form.setFieldsValue({
                            name: res.data.name,
                            name_short: res.data.name_short,
                            product_group_id: res.data.product_group_id[0].id,
                            weight: res.data.weight,
                            unit: res.data.unit[0].id,
                            amount_in_a_package: res.data.amount_in_a_package,
                            pattern_activity: res.data.pattern_activity.map(p => p.id),
                            weight_product: !!res.data.weight_product
                        })
                        setPicture(res.data.picture)
                        setWait(false);
                    })
                    .catch((e) => {
                        if (e.request.status === 403) {
                            setToken(null)
                        } else {
                            setWait(false)
                            errorConnect()
                        }
                    });
            } else {
                setWait(false);
            }
        }
    }, [isLoadSystem])

    useEffect(() => {
        window.scroll(0, 0)
        axios.all([getActiveProductsGroups(), getActiveUnits(), getActivePatternActivities()])
            .then(axios.spread((group, units, pattern) => {
                setProductsGroup(group.data);
                setUnit(units.data);
                setPatternActivities(pattern.data)
                setIsLoadSystem(false);
            }))
            .catch((e) => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    setWait(false)
                    errorConnect()
                }
            })

    }, [])

    const checkActiveGroup = (group_id) => {
        let active = true;
        productsGroup.map(pg => {
                if (pg.id === group_id && pg.status === 0) {
                    active = false;
                }
            }
        )
        return active;
    }

    const checkActiveUnit = (unit_id) => {
        let active = true;
        unit.map(u => {
                if (u.id === unit_id && u.status === 0) {
                    active = false;
                }
            }
        )
        return active;
    }

    const onFinish = async (values) => {
        setWait(true);

        if (!checkActiveGroup(values['product_group_id'])) {
            setWait(false);
            return
        }

        if (!checkActiveUnit(values['unit'])) {
            openNotificationFailedActive(t('save').toLowerCase(), t('unit').toLowerCase())
            setWait(false);
            return
        }

        const formData = new FormData();
        formData.append('name', values["name"])
        formData.append('name_short', values["name_short"])
        formData.append('product_group_id', values["product_group_id"])
        formData.append('weight', values["weight"])
        formData.append('unit', values["unit"])
        formData.append('amount_in_a_package', values["amount_in_a_package"])
        formData.append('pattern_activity', values["pattern_activity"])
        formData.append('weight_product', (values["weight_product"] ? 1 : 0))
        if (params.id != null) {
            formData.append('id', params.id)
        }

        if (pictureFile !== undefined) {
            formData.append('picture', pictureFile)
        }


        if (params.id === null) {
            createProduct(formData)
                .then(res => {
                    if (res.status === 200) {
                        // navigate("/products", {replace: true});
                        navigate(-1)
                    } else if (res.status === 202) {
                        notification.error({
                            message: t('failed'),
                            description:
                                t('e_duplicate_product'),
                            placement: 'top'
                        });
                        setWait(false)
                    } else {
                        openNotificationFailed(t('creating'));
                    }
                })
                .catch((e) => {
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                })

        } else {
            updateProduct(formData)
                .then(res => {
                    if (res.status === 200) {
                        // navigate("/products", {replace: true});
                        navigate(-1)
                    } else {
                        openNotificationFailed(t('updating'));
                    }
                })
                .catch((e) => {
                    if (e.request.status === 403) {
                        setToken(null)
                    } else {
                        setWait(false)
                        errorConnect()
                    }
                })
        }

    }

    const copyProduct = () => {
        if (params.id != null) {
            navigate("/site/products/product", {replace: true, state: {copy: params.id}})
        }
    }


    return (
        <Spin spinning={wait} delay={300}>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>{t('product')}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Space>
                        <BackButton />
                        <Button shape="round" type="primary" htmlType="submit" form={"form"}>
                            {t('save')}
                        </Button>
                    </Space>
                </Space>


                <Space size={40} style={{display: "flex", alignItems: 'stretch'}} wrap>
                    <Form form={form}
                          style={{width: '50vh'}}
                          layout={"vertical"}
                          onFinish={onFinish}
                          autoComplete="off"
                          id={"form"}
                    >
                        <Form.Item style={{marginBottom: '10pt'}}
                                   name="name"
                                   label={t('name')}
                                   rules={[
                                       {
                                           required: true,
                                           message: t('e_input', {input: t('name').toLowerCase()}),
                                       },
                                   ]}
                                   hasFeedback
                        >
                            <Input/>
                        </Form.Item>

                        <Form.Item style={{marginBottom: '10pt'}}
                                   name="name_short"
                                   label={t('short_name')}
                                   rules={[
                                       {
                                           required: true,
                                           message: t('e_input', {input: t('short_name').toLowerCase()}),
                                       },
                                   ]}
                                   hasFeedback
                        >
                            <Input/>
                        </Form.Item>

                        <Form.Item style={{marginBottom: '10pt'}}
                                   name="weight"
                                   label={t('weight')}
                                   rules={[
                                       {
                                           required: true,
                                           message: t('e_input', {input: t('weight').toLowerCase()}),
                                       },
                                   ]}
                                   hasFeedback
                        >
                            <Input type={'number'} step={"0.001"}/>
                        </Form.Item>

                        <Form.Item style={{marginBottom: '10pt'}}
                                   name="unit"
                                   label={t('unit')}
                                   rules={[
                                       {
                                           required: true,
                                           message: t('e_select', {select: t('unit').toLowerCase()}),
                                       },
                                   ]}
                                   hasFeedback
                        >
                            <Select allowClear>
                                {unit.map(u =>
                                    <Select.Option key={u.id} value={u.id}
                                                   disabled={u.status === 0}>{u.name}</Select.Option>
                                )}
                            </Select>
                        </Form.Item>

                        <Form.Item style={{marginBottom: '10pt'}}
                                   name="amount_in_a_package"
                                   label={t('amount_in_a_package')}
                                   rules={[
                                       {
                                           required: true,
                                           message: t('e_input', {input: t('amount_in_a_package').toLowerCase()}),
                                       },
                                   ]}
                                   hasFeedback
                        >
                            <Input type={'number'}/>
                        </Form.Item>

                        <Form.Item style={{marginBottom: '10pt'}}
                                   name="weight_product"
                                   valuePropName='checked'
                            // noStyle
                        >
                            <Checkbox>{t('weight_product')}</Checkbox>
                        </Form.Item>

                        <Form.Item style={{marginBottom: '10pt'}}
                                   name="product_group_id"
                                   label={t('product_group')}
                                   rules={[
                                       {
                                           required: true,
                                           message: t('e_select', {select: t('product_group').toLowerCase()}),
                                       },
                                   ]}
                                   hasFeedback
                        >
                            <Select allowClear>
                                {productsGroup.map(pg =>
                                    <Select.Option key={pg.id} value={pg.id}
                                                   disabled={pg.status === 0}>{pg.name}</Select.Option>
                                )}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            name={"pattern_activity"}
                            label={t('pattern_activity')}
                            rules={[
                                {
                                    required: true,
                                    message: t('e_select', {select: t('pattern_activity').toLowerCase()}),
                                },
                            ]}
                            hasFeedback
                            style={{marginBottom: '10pt'}}
                        >
                            <Select mode={"multiple"} allowClear>
                                {patternActivities.map(pattern => {
                                        if (pattern.status !== 0) {
                                            return <Select.Option key={pattern.id} value={pattern.id}
                                                                  disabled={pattern.status === 0}>{t(pattern.name)}</Select.Option>
                                        }
                                    }
                                )}
                            </Select>
                        </Form.Item>
                    </Form>

                    {params.id != null ? <VendorCode id={params.id}/> : null}
                    <Space direction="vertical" style={{width: '80vh'}}>
                    <Image
                        src={picture}
                        style={{
                            width: '100pt',
                            height: '100pt',
                            borderRadius: '15pt'
                        }}
                        fallback="data:image/png;base64,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"
                    />
                    <Upload
                        name="picture"
                        showUploadList={false}
                        action={picture_upload}
                        onChange={handleChange}
                        accept="image/png,image/jpeg,image/jpg"
                    >
                        <Button
                            icon={<UploadOutlined/>}
                            style={{marginTop: '15pt'}}>
                            {picture ? t('update') : t('download')}
                        </Button>
                    </Upload>
                    </Space>
                </Space>
            </div>

            <Outlet/>
        </Spin>
    )
}

export default EditProducts